export default {"src":"/_next/static/media/windows.0a3dc4d6.svg","height":48,"width":155,"blurWidth":0,"blurHeight":0};